import React, { useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';

const MessageSnackbar = ({ open, message, onClose, severity }) => {
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        onClose(); // Close snackbar after 4 seconds
      }, 4000);

      return () => clearTimeout(timer); // Cleanup timer if component unmounts
    }
  }, [open, onClose]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Position set to top-right
    >
      <Alert
        onClose={onClose}
        severity={severity} // Automatically adjusts the icon based on severity
        sx={{
          width: 'auto',
          fontSize: '16px',
          padding: '12px 24px',
          borderRadius: '12px',
          backgroundColor: severity === 'success' ? '#12538B' : '#D32F2F', // Blue for success, red for error
          color: '#FFF',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          '& .MuiAlert-icon': {
            color: '#FFF', // Make icon color white
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default MessageSnackbar;
